export default __webpack_public_path__ + "static/media/fb.51520bb0.svg";